'use strict';

import React from 'react';
import { Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from 'react-select';
import cn from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { ordersOperations, ordersSelectors } from '@/state/domains/orders';
import { attemptsOperations, attemptsSelectors } from '@/state/domains/attempts';

import ServeDetails from '@/views/common/ServeDetails';
import BadAddressDetails from '@/views/common/BadAddressDetails';

import s from './styles.scss';

const sx = cn.bind(s);

class AttemptsPage extends React.Component {

	constructor() {

		super();

		this.state = {
			showMenu: false,
		};

		[
			'toggleMenu',
		].forEach(fn => { this[fn] = this[fn].bind(this) });
	}

	componentDidMount() {

		const {
			user,
			username,
			date,
			attempts,
			assigned,
			fetchUser,
			fetchAssigned,
			fetchUserDailyAttempts,
		} = this.props;

		if (!user) {
			fetchUser(username);
		}

		if (!attempts) {
			const tzOffset = format(new Date(), 'xxx');
			fetchUserDailyAttempts(username, tzOffset, date);
		}

		if (!assigned) {
			fetchAssigned(username, date);
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {

		const {
			username,
			date,
			attempts,
			assigned,
			fetchUserDailyAttempts,
			fetchAssigned,
		} = this.props;

		const tzOffset = format(new Date(), 'xxx');
		
		if (date != prevProps.date) {

			if (!attempts) {
				fetchUserDailyAttempts(username, tzOffset, date);
			}

			if (!assigned) {
				fetchAssigned(username, date);
			}
		}
	}

	toggleMenu() {
		const { showMenu } = this.state;
		const cb = showMenu ?
			() => document.removeEventListener('click', this.toggleMenu) :
			() => document.addEventListener('click', this.toggleMenu);

		this.setState({ showMenu: !showMenu }, cb);
	}

	render() {

		const {
			date,
			username,
			prevDay,
			attempts,
			getJobById,
		} = this.props;

		const { showMenu } = this.state;

		return (
			<div className={ s.attemptsPage }>
				{ !!attempts && 
					<table>
						<thead>
							<tr>
								<th></th>
								<th>Time</th>
								<th>ID</th>
								<th>Recipient</th>
								<th>Address</th>
								<th>Details</th>
							</tr>
						</thead>
						<tbody>
							{
								attempts.map(a => {
									const job = getJobById(a.jobId);

									if (!job) {
										return null;
									}

									const jobComplete = a.serve || a.badAddress;
									const { property, subunit } = job;
									const { streetNumber, streetName, city, state, zip } = property;
									const subunitName = subunit ? subunit.name : '';
									/*const address = (
										<div>
											<div>{ `${ streetNumber } ${ streetName }` }</div>
											{ subunitName && <div>{ subunitName }</div> }
											<div>{ `${ city }, ${ state } ${ zip }` }</div>
										</div>
									);*/
									const address = `${ streetNumber } ${ streetName }`;
									let details;
									
									if (!jobComplete) {
										details = a.details ? a.details.join(', ') : '';

									} else {
										if (job.served) {
											details = <ServeDetails { ...job.serveDetails } />;
										} else {
											details = <BadAddressDetails { ...job.badAddressDetails } />;
										}
									}

									return (
										<tr>
											<td className={ s.type }>{ jobComplete ?
												( job.served ? 'Serve' : 'Bad Address' ) :
												'Attempt'
											}</td>
											<td className={ s.time }>{ format(new Date(a.date), 'HH:mm') }</td>
											<td className={ s.id }>{ a.jobId }</td>
											<td className={ s.recipient }>{ job.recipient }</td>
											<td className={ s.address }>{ address }</td>
											<td className={ s.details }>{ details }</td>
										</tr>
									)
								}).filter(a => a)
							}
						</tbody>
					</table>
				}
			</div>
		);
	}
}


export default connect(
	(state, props) => ({
		username: usersSelectors.getUsername(state, props),
		user: usersSelectors.getPageUser(state, props),
		date: appSelectors.getPageDate(state, props),
		getJobById: id => ordersSelectors.getJobById(state, props)(id),
		attempts: attemptsSelectors.getDailyAttempts(state, props),
	}),
	{
		fetchUser: usersOperations.fetchUser,
		fetchUserDailyAttempts: attemptsOperations.fetchUserDailyAttempts,
		fetchAssigned: ordersOperations.fetchAssigned,
	}
)(AttemptsPage);
